module.exports = __webpack_public_path__ + "assets/img/0468-eh.svg";